import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Container, Divider, Header} from 'semantic-ui-react';

export default function NotFoundPage({location}) {
  if (location.pathname === '/api/login') {
    return <div>Logging in...</div>;
  }
  return (
    <Container textAlign="center">
      <Divider hidden/>
      <Header size="huge">404!</Header>
      <Header>Looks like the page you're looking for doesn't exist.</Header>
      <Container>
        You could go back to the <Link to="/">Signature Dashboard</Link> or contact us at
      </Container>
      <Container>
        <a className="mail-customer-care"
           href="mailto:customercare@corelogic.com.au">customercare@corelogic.com.au</a>
      </Container>
      <Container>1300 734 318</Container>
    </Container>
  );
}

NotFoundPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};
